<template>
	<!-- 批量审核结果弹窗 -->
	<el-drawer
		class="opearor-result"
		size="820px"
		title="操作结果"
		:visible.sync="resultDialogVisble"
		:append-to-body="true"
		:wrapperClosable="false"
		@closed="onKnow"
	>
		<div class="mt-24 ml-24 mr-24 drawer-content">
			<p>
				本次共操作
				<span class="font-h4-medium">{{ auditResult.total }}</span>
				个商品
			</p>
			<p>
				<span class="font-h4-medium yx-color-success">{{ auditResult.success }}</span>
				个操作成功，
				<span class="font-h4-medium yx-color-danger">{{ auditResult.fail }}</span>
				个操作失败
			</p>
			<el-table class="result-table mt-16" ref="table" :data="auditResult.list" style="width: 100%">
				<el-table-column min-width="300" label="失败商品">
					<template slot-scope="{ row }">
						<div class="flex flex-align-center">
							<img class="product-img mr-8" :src="row.product_pic" alt="" />
							<div>
								<div class="flex flex-align-center">
									<rd-text :value="row.product_name" :width="217"></rd-text>
									<ID-tag style="min-width: 20px" label="商品ID" :id="row.third_product_id" />
								</div>
								<div style="color: #86909c" class="flex flex-align-center fz-12">
									<div>售价：{{ row.price | formatPrice }}</div>
									<div class="line-table ml-8 mr-8"></div>
									<div>库存：{{ sumFormat(row.product_stock) }}</div>
									<div class="line-table ml-8 mr-8"></div>
									<div>销量：{{ sumFormat(row.sales) }}</div>
								</div>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column minWidth="300" label="失败原因">
					<template slot-scope="{ row }">
						<div class="flex flex-align-center yx-color-pure-1 font-h4-regular">
							{{ row.reason }}
						</div>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="bott">
			<el-button type="primary" @click="onKnow">我知道了</el-button>
		</div>
	</el-drawer>
</template>
 <script>
import IDTag from '@/components/ui/IDTag';
export default {
	components: {
		IDTag,
	},
	props: {
		auditResult: {
			type: Object,
			default: () => ({}),
		},
	},
	data() {
		return {
			resultDialogVisble: false,
		};
	},
	methods: {
		show() {
			this.resultDialogVisble = true;
		},
		sumFormat(currency) {
			if (!currency) {
				return '-';
			}
			const temp = Number(currency);
			if (temp < 10000) {
				return `${temp}`;
			}
			if (temp >= 10000 && temp < 100000000) {
				return `${(temp / 10000).toFixed(2)}w`;
			}
			return `${(temp / 100000000).toFixed(2)}亿`;
		},
		onKnow() {
			this.resultDialogVisble = false;
		},
	},
};
</script>
 <style lang="less" scoped>
.gap-16 {
	gap: 16px;
}
.import-content {
	.title {
		font-size: 14px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #323233;
	}
	.desc {
		font-size: 12px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #969799;
		line-height: 18px;
	}
	.link {
		font-size: 12px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #ee0a24;
		line-height: 18px;
	}
}
.opearor-result {
	/deep/ .el-drawer__body {
		background: @color-gy2;
		padding: 0px 0px 0px !important;
	}
}
.drawer-content {
	padding: 16px;
	background: #fff;
	border-radius: 12px;
}
.bott {
	position: absolute;
	bottom: 0;
	left: 0;
	height: 64px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	padding-right: 20px;
	width: 100%;
	/* 超/灰/G1 */
	background: #ffffff;
	box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.1);
	z-index: 2000;
}
/deep/ .el-table thead {
	color: #1d2129 !important;
	font-size: 14px !important;
}
.product-img {
	width: 40px;
	height: 40px;
	border-radius: 4px;
}
.line-table {
	width: 1px;
	height: 8px;
	background: #a9aeb8;
}
</style>